import { render, staticRenderFns } from "./trigger-config.vue?vue&type=template&id=3e2bbb3b"
import script from "./trigger-config.ts?vue&type=script&lang=js&external"
export * from "./trigger-config.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports